import rest from '@modules/rest'
import upload from '@modules/upload'
import middleware from '@graphql/middleware'
import * as get from '@graphql/middleware/queries'
import { getUploadEndpoint } from '@modules/fileHelpers'
import { getEmployeeInfoSchema } from '@services/systemField'
import { ADDRESSES_CONTACTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import * as mappers from '@convenia/common-organisms/SystemFields/content/mappers/address'

export async function getOptions () {
  const [ err, { options: data = {} } = {} ] = await middleware(get.GetAddressContactsOptions)
  const options = {
    emergency: {
      emergencyRelations: data.emergencyRelations
    }
  }

  return [ err, options ]
}

export const getAddress = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/addresses/employee`

    const { data } = await rest.get(url)

    const address = mappers.mapAddress(data)

    return [ null, address ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateAddress = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/addresses/employee`
    const body = mappers.mapAddressInput({ data, schema })

    const response = await rest.post(url, { body, headers: { bcv: true } })

    const address = mappers.mapAddress(response?.data || {})

    return [ null, address ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getContacts = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/contact-information/employee`

    const { data } = await rest.get(url)

    const contacts = mappers.mapContacts(data)

    return [ null, contacts ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateContact = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/contact-information/employee`
    const body = mappers.mapContactInput({
      data,
      schema,
    })

    const response = await rest.post(url, { body })

    const contacts = mappers.mapContacts(response?.data || {})

    return [ null, contacts ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getEmergencyContacts = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/employee`

    const { data } = await rest.get(url)

    const emergencyContacts = (data || [])
      .map(mappers.mapEmergencyContact)

    return [ null, emergencyContacts ]
  } catch (err) {
    return [ err, null ]
  }
}
export const createEmergencyContact = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/employee`
    const body = mappers.mapEmergencyContactInput({ data, schema })

    const response = await rest.post(url, { body })

    const emergencyContact = mappers.mapEmergencyContact(response?.data || {})

    return [ null, emergencyContact ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateEmergencyContact = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/${data.id}/employee`
    const body = mappers.mapEmergencyContactInput({ data, schema, entityId: data?.id })

    await rest.put(url, { body })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}
export const deleteEmergencyContact = async ({ id }, params) => {
  try {
    if (typeof id !== 'string')
      return [ null, null ]

    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/emergency-contacts/${id}/employee`

    await rest.delete(url)

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}
export const mapSection = data => ({
  schema: data?.schema || {},
  values: data?.values || {}
})

export const mapCustomFields = data => ({
  address: mapSection(data.find(({ id }) => id === ADDRESSES_CONTACTS_AREA.ADDRESS)),
  contact: mapSection(data.find(({ id }) => id === ADDRESSES_CONTACTS_AREA.CONTACTS)),
  emergencyContact: mapSection(data
    .find(({ id }) => id === ADDRESSES_CONTACTS_AREA.EMERGENCY_CONTACTS)),
})

export const getCustomFields = async (params) => {
  const { employeeId, companyId } = params
  const [ err, data ] = await getEmployeeInfoSchema({
    employeeId,
    companyId,
    area: ADDRESSES_CONTACTS_AREA.LABEL
  })

  const customFields = mapCustomFields(data)

  return [ err, customFields ]
}

export const uploadAddressFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'address')

    await upload({ files, endpoint })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}
